import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import RowEditIcon from './RowEditIcon';
import { TableCell } from '@mui/material';

const PayoutInfoRow = ({ row, count, tableHeader, enableEdit,stickyEnabled }) => {
    // get context variables from parent
    const {
        editPayoutInfoModal, 
        setEditPayoutInfoModal, 
        editPayoutInfoRow, 
        setEditPayoutInfoRow, 
    } = useContext(PageContext);

    // event handler for edit click 
    const onEditClick = () => {
        setEditPayoutInfoRow(editPayoutInfoRow => editPayoutInfoRow = row);
        setEditPayoutInfoModal(editPayoutInfoModal => editPayoutInfoModal = true);
    }

    // show red icon for disabled (false) status or green icon for Active (true) status 
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return (
        <>
            {/* map logic over all elements of row */}
            {tableHeader.map(el => 
                // show circles for status 
                el['columnname'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                // if allowEdit flag is true show edit icon to activate EditRebateSetupModal 
                : el['columnname'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        {/* show edit icon to trigger EditSubCompanyRow modal */}                      
                        <RowEditIcon enable={enableEdit} onClick={onEditClick}/>
                    </TableCell>
                : el['columnname'] == 'companyid' ?
                <>
                    {row[el['columnname']] == process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>MASTER</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
                // show None if cell is null
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                // standard display for all other columns 
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
            
        </>
    );
}

export default PayoutInfoRow; 